
import { utils } from '@/components/medical-core'
import { getSignDownload } from '@/components/medical-core/utils/Signature';
import { getToken } from '../utils';

export function urlAuthBg(oldUrl) { // 适用于background-image的授权方法
    const token = getToken()
    if (utils.isNull(token)) {
        console.error('==> v-url: 鉴权图片在首次获取token失败 ')
    }
    const isBase64 = oldUrl && (oldUrl.indexOf('data:image/') > -1 || oldUrl.indexOf('blob:') > -1)
    const timestamp = utils.getTimeStamp();
    const sign = getSignDownload(oldUrl, token, timestamp);
    return isBase64 ? oldUrl : `${oldUrl}?t=${token}&ts=${timestamp}&s=${sign}`
}

export default function urlAuth() {
    let token = getToken()
    if (utils.isNull(token)) {
        console.error('==> v-url: 鉴权图片在首次获取token失败 ')
    }
    const setUrl = function (el, binding, vnode) {
        if(utils.isNull(token)){ //如果没有token，重新获取token
            token = getToken();
        }
        if (binding.value == binding.oldValue) {
            return
        }
        const oldUrl = binding.value;
        const isBase64 = oldUrl && (oldUrl.indexOf('data:image/') > -1 || oldUrl.indexOf('blob:') > -1)
        const timestamp = utils.getTimeStamp();
        const sign = getSignDownload(oldUrl, token, timestamp);
        const url = isBase64 ? oldUrl : `${oldUrl}?t=${token}&ts=${timestamp}&s=${sign}`
        el.setAttribute("src", url);
    }
    return {
        inserted: setUrl,
        update: setUrl
    }
}
